export const CheckStatusIcon: React.FC = ({}) => {
    return(
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 18">
      <path id="Caminho_268" data-name="Caminho 268" d="M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM7.968,12.427,4.535,8.993,5.905,7.622,7.962,9.678l4.112-4.112,1.385,1.371Z" fill="#114d88"/>
    </svg>
  )
}